<template>
    <div class="template-base">        
        <MessageBoxV3 v-show="messageBox_show" ref="refMessageBox" />
        <Header Title="Subscriptions" :iconPath="'/images/icons/subscription.png'" class="div-header" ></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" ></Button>
            <Button class="x-smaller-button" :buttonModel="btnAdd" @on-clicked="newItem_show = true" />
            <Button class="x-smaller-button" :buttonModel="btnViewSubscribers" @on-clicked="showSubscribers = true" />
        </div>
        <div class="select-button-container div-body" style="overflow-y: auto;" v-if="!fetchingData">
            <div class="select-button-container">
                <SubscriptionItem v-for="subscriptionModel in subscriptionModels" :key="subscriptionModel.globalId" 
                :item="subscriptionModel" 
                :categoryList="categoryList" 
                :locations="locations"                 
                @on-delete="onDelete" 
                @on-dirty="onDirty" 
                @on-qrCode="onSetupQrCode" 
                @on-activate="onActivate"
                @on-deactivate="onDeactivate" />
            </div>
        </div>
        <iframe ref="refPrintFrame" src="" frameborder="0" width="0px" height="0px" ></iframe>
    </div>
    <NewItem v-if="newItem_show" @on-cancel="newItem_show = false" @on-ok="addItem" :title="'New Subscription'" :okText="'Create'" :minLength="3" :maxLength="40"/>
    <SubscriberList v-if="showSubscribers" @on-close="showSubscribers = false" />
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import apiCategory from "@/api/apiCategory";
import apiSubscription from "@/api/apiSubscription";
import apiLocation from "@/api/apiLocation";
import { ref } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import { onBeforeRouteLeave } from 'vue-router';
import PortalUserModel from "@/common/models/PortalUserModel";
import SubscriptionItem from "./components/Administrator/SubscriptionItem.vue";
import SubscriberList from "./components/Administrator/SubscriberList.vue";
import NewItem from "@/views/components/Shared/NewItem";
import MessageBoxV3 from "@/views/components/Shared/MessageBoxV3";
// import Helper from "@/common/helper";

export default {
    components: {
        Header,
        Button,
        MessageBoxV3,
        SubscriptionItem,
        SubscriberList,
        NewItem
    },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);
        const subscriptionModels = ref([]);                
        const categoryList = ref([]);        
        const locations = ref([]);        
        const messageBox_show = ref(false);    
        const refMessageBox = ref(null)
        const refSubscriptionBox = ref(null)
        const refPrintFrame = ref(null)
        const newItem_show = ref(false)
        const showSubscribers = ref(false)

        var dirtyCount = 0;


        onMounted(() => {
            getData();
        });
        const portalUser = ref(PortalUserModel.fromToken());

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";        

        const btnAdd = ButtonModel.CreateClick("");
        btnAdd.iconPath = "/images/icons/add.png"
        btnAdd.title = "Add Subscription..."

        const btnViewSubscribers = ButtonModel.CreateClick("");
        btnViewSubscribers.iconPath = "/images/icons/members.png"
        btnViewSubscribers.title = "View Subscribers..."


        onBeforeRouteLeave((/*to, from*/) => {
            // check if any components are dirty
            if (dirtyCount > 0) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }            
        });

        window.onbeforeunload = () => {
            if (dirtyCount > 0) {
                const answer = window.confirm("Do you really want to leave? You have unsaved changes!");
                if (!answer) return false;
            }
        };

        const onDirty = (isDirty) => {
            if (isDirty) dirtyCount++;
            else dirtyCount--;
        };

        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;

                categoryList.value = await apiCategory.getSubscriptionList();
                subscriptionModels.value = await apiSubscription.getAll();                
                locations.value = await apiLocation.getAll();
        
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };        


        const addItem = async (subscriptionName) => {
            try {                
                emitter.emit("server-call-start", "Creating subscription...");                
                var item = await apiSubscription.create(subscriptionName);
                subscriptionModels.value.push(item);                
                subscriptionModels.value.sort((a, b) =>a.title.localeCompare(b.title, undefined, { sensitivity: "base" }));
                // subscriptionModels.value.sort((a, b) => b.activeTimestamp?.localeCompare(a.activeTimestamp, undefined, { sensitivity: "base" }));
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error creating subscription", err]);
            }
            emitter.emit("server-call-stop");
        };
        
        const onDelete = async (item) => {            

            refMessageBox.value.showDialog("Are you sure you want to delete subscription " + item.title + "?",
             "Delete Subscription",            
             deleteItem.bind(this,item),
            () => { return messageBox_show.value = false; } )
            messageBox_show.value = true;
        };

        const deleteItem = async (item) => {
            try {                
                emitter.emit("server-call-start", "Deleting subscription...");
                dirtyCount = 0
                await apiSubscription.delete(item.globalId);
            } catch (err) {
                console.log("ERROR:", err);                
                emitter.emit("show-alert", ["Error deleting subscription", err]);
            }
            emitter.emit("server-call-stop");

            messageBox_show.value = false;
            await getData()            
        }; 
        


        const onActivate = async (item) => {            
        
            let message = `Do you want to activate subscription "${item.title}"?\n\nAny subscribers will move to this subscription after their next renewal.`
            let pYesText = "Yes"
            let pNoText = "No"
        
            const activeSubscription = subscriptionModels.value.find(x=> x.isActive)            

            if (activeSubscription != null) {
                message = `Subscription "${activeSubscription.title}" is active. Only one subscription can be marked active.\n\nDeactivate "${activeSubscription.title}" first.`
                pYesText = ""
                pNoText = "Cancel"
            }

            refMessageBox.value.showDialog(
                message,
                "Activate Subscription",   
                    
                // Yes
                async () => {                    
                        try {                
                            emitter.emit("server-call-start", "Activating subscription...");                
                            await apiSubscription.activate(item.globalId);

                            const activeItem = subscriptionModels.value.find(x=> x.globalId == item.globalId)
                            activeItem.isActive = true;                        

                        } catch (err) {
                            console.log("ERROR:", err);                
                            emitter.emit("show-alert", ["Error activating subscription", err]);
                        }
                        emitter.emit("server-call-stop");
                        messageBox_show.value = false;                                                           
                }, 

                // NO
                () => { 
                    return messageBox_show.value = false; 
                },
            
                pYesText,
                pNoText

            )
            messageBox_show.value = true;            
        };
        

        const onSetupQrCode = (purchaseLink, title) => {
            var url = window.location.origin + `/qr-code-generator-subscriptions.html?textValue=${encodeURIComponent(purchaseLink)}&subscriptionName=${title}&printFlag=yes`
            refPrintFrame.value.src = url        
        };

        
        const onDeactivate = async (item) => {            
        
            let message = `Do you want to deactivate subscription "${item.title}"?\n\nAll subscribers will not be renewed at the next cycle, unless another subscription is activated.`


            refMessageBox.value.showDialog(
                message,
                "Deactivate Subscription",   
                    
                // Yes
                async () => {
                        try {                
                            emitter.emit("server-call-start", "Deactivating subscription...");                
                            await apiSubscription.deactivate(item.globalId)

                            const activeItem = subscriptionModels.value.find(x=> x.globalId == item.globalId)
                            activeItem.isActive = false;

                        } catch (err) {
                            console.log("ERROR:", err);                
                            emitter.emit("show-alert", ["Error deactivating subscription", err]);
                        }
                        emitter.emit("server-call-stop");
                        messageBox_show.value = false;                                                           
                }, 

                // NO
                () => { 
                    return messageBox_show.value = false; 
                }
            )
            messageBox_show.value = true;                
        };

        return {
            portalUser,
            btnExit,
            fetchingData,
            subscriptionModels,
            categoryList,
            btnAdd,
            btnViewSubscribers,
            showSubscribers,
            onDirty,
            messageBox_show,        
            refMessageBox,
            refSubscriptionBox,
            onSetupQrCode,
            refPrintFrame,
            newItem_show,
            addItem,
            onDelete,
            locations,
            onActivate,   
            onDeactivate         
        };
    }
};
</script>

<style scoped>

.setting-item {
    width: 100%;
    min-width: 100px;
    /* background-color: lightblue; */
    margin: 5px;
    border-radius: 8px;
    padding: 5px;
    font-size: 12pt;
    font-weight: 200;
    font-family: "Roboto", sans-serif;
    align-self: flex-start;
}
.subscription-input-container {
    display: flex;
    /* justify-content: space-between; */
    margin: 10px;
    padding-left: 5%;
}

.subscription-input-container-grid {
    display: flex;
    flex-direction: column;
    margin: 10px 10px 10px 0px;
}

.subscription-input-item {
    width: 200px;
}

.subscription-name {
    width: 200px;
}

.setting-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
    width: 100%;
}

.setting-header-bar {
    width: 100%;
}

.setting-header-label {
    /* color: var(--card-body-border); */
    text-transform: uppercase;
    font-size: 10pt;
}

.subscription-input-item-select {
    width: 210px;
}
</style>
